export const SIGN_IN_LOADING = "auth/SIGNIN_LOADING";
export const SIGN_IN_SUCCESS = "auth/SIGNIN_SUCCESS";
export const SIGN_IN_ERROR = "auth/SIGNIN_ERROR";

export const SIGN_OUT_LOADING = "auth/SIGNOUT_LOADING";
export const SIGN_OUT_SUCCESS = "auth/SIGNOUT_SUCCESS";
export const SIGN_OUT_ERROR = "auth/SIGNOUT_ERROR";

export const SIGN_UP_LOADING = "auth/SIGNUP_LOADING";
export const SIGN_UP_SUCCESS = "auth/SIGNUP_SUCCESS";
export const SIGN_UP_ERROR = "auth/SIGNUP_ERROR";
